import { render, staticRenderFns } from "./BankStatement.vue?vue&type=template&id=a485c7f0&scoped=true"
import script from "./BankStatement.vue?vue&type=script&lang=js"
export * from "./BankStatement.vue?vue&type=script&lang=js"
import style0 from "./BankStatement.vue?vue&type=style&index=0&id=a485c7f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a485c7f0",
  null
  
)

export default component.exports